import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { PresetService } from '../../backend';
import { currentBuilderState } from '../builder.state';

export function deletePreset(presetId: string): Observable<boolean> {
    const presetService =
        epicDependencies.injector.get<PresetService>(PresetService);

    const state = currentBuilderState();

    return presetService.delete(presetId).pipe(
        tap(() => {
            state.presets?.splice(
                state.presets?.findIndex((e) => e.presetId === presetId),
                1,
            );
        }),
        catchErrorLogRet(false),
    );
}
